module.exports = __webpack_public_path__ + "img/logo-todoist.ac81296a.svg";